import React, { useState, useEffect } from "react";
import {
  FaBars, FaTimes, FaPhoneAlt, FaFacebookF, FaInstagram, FaLinkedinIn,
  FaEnvelope, FaChevronDown, FaUserNurse, FaBaby, FaHome,
  FaUtensils, FaCar, FaBroom, FaFemale, FaGoogle
} from "react-icons/fa";

import "../Css/Header.css";
import logo from "../assets/svk-maid-logo.png";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

const serviceList = [
  { name: "Patient Care", icon: <FaUserNurse />, link: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", icon: <FaBaby />, link: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", icon: <FaHome />, link: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", icon: <FaUtensils />, link: "/services/cooking-service-in-mumbai" },
  { name: "Driver", icon: <FaCar />, link: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", icon: <FaBroom />, link: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", icon: <FaFemale />, link: "/services/japa-maid-service-in-mumbai" },
];

  const closeSidebar = () => {
    setOpen(false);
    setServicesOpen(false);
  };

  return (
    <>
      {/* TOP INFO BAR */}
      <div className="top-info-bar">
        <div className="top-info-inner">
          <div className="top-left">
            <a href="tel:+917304398067" className="top-link"><FaPhoneAlt /> +91 73043 98067</a>
             <a href="mailto:info@tanyamaidservice.com" className="top-link"><span className="hide-mobile"><FaEnvelope /> info@tanyamaidservice.com</span></a>
            {/* <div className="top-link">
  
  <a
    href="https://g.page/r/YOUR-GMB-LINK"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaGoogle className="top-icon google" />
    oogle my business
  </a>
</div> */}

          </div>
          <div className="top-right">
            <div className="social-group">
              <a href="https://share.google/gT1cdg9ghPzTtDVnW" className="social-circle" target="_blank" rel="noopener noreferrer"><FaGoogle /></a>
              <a href="https://www.instagram.com/tanya_maid_service/" className="social-circle" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/tanyamaidservice" className="social-circle" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/tanya-maid-service/" className="social-circle" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN NAV BAR */}
      <header className="main-nav-bar">
        <div className="nav-inner">
          <div className="nav-logo">
            <a href="/"><img src={logo} alt="Tanya Maid Service" /></a>
          </div>

          <nav className="nav-menu">
            <a href="/" className={currentPath === "/" ? "active" : ""}>HOME</a>
            <a href="/about-us" className={currentPath === "/about-us" ? "active" : ""}>ABOUT US</a>
            <div className="dropdown">
              <button className={`dropbtn ${currentPath.includes("/services") ? "active" : ""}`}>
                <a href="/services" className={currentPath === "/services" ? "active" : ""}>SERVICES </a><FaChevronDown className="drop-icon" />
              </button>
              <div className="dropdown-card">
                {serviceList.map((service, index) => (
                  <a key={index} href={service.link} className="dropdown-item">
                    <span className="item-icon">{service.icon}</span> {service.name}
                  </a>
                ))}
              </div>
            </div>
            <a href="/contact" className={currentPath === "/contact" ? "active" : ""}>CONTACT</a>
          </nav>

          <div className="nav-actions">
            <a href="tel:+917304398067" className="nav-cta hide-tablet">CALL NOW</a>
            <button className="nav-hamburger" onClick={() => setOpen(true)}><FaBars /></button>
          </div>
        </div>

        {/* CENTERED MOBILE SIDEBAR */}
        <div className={`sidebar-overlay ${open ? "show" : ""}`} onClick={closeSidebar} />
        <aside className={`mobile-sidebar ${open ? "active" : ""}`}>
          <button className="close-btn-top" onClick={closeSidebar}><FaTimes /></button>
          
          <div className="sidebar-content-wrapper">
            <div className="sidebar-logo-centered">
              <img src={logo} alt="Logo" />
            </div>
            
            <nav className="sidebar-links-centered">
              <a href="/" className={currentPath === "/" ? "active" : ""} onClick={closeSidebar}>Home</a>
              <a href="/about-us" className={currentPath === "/about-us" ? "active" : ""} onClick={closeSidebar}>About Us</a>
              
              <div className="mobile-collapsible-centered">
                <div 
                  className={`mobile-sub-header-centered ${currentPath.includes("/services") ? "active" : ""}`} 
                  onClick={() => setServicesOpen(!servicesOpen)}
                >
                  OUR SERVICES <FaChevronDown className={`chevron ${servicesOpen ? "rotate" : ""}`} />
                </div>
                
                <div className={`mobile-services-grid-centered ${servicesOpen ? "show" : ""}`}>
                  {serviceList.map((s, i) => (
                    <a key={i} href={s.link} onClick={closeSidebar} className={`m-grid-item ${currentPath === s.link ? "active" : ""}`}>
                       {s.name}
                    </a>
                  ))}
                </div>
              </div>
              
              <a href="/contact" className={currentPath === "/contact" ? "active" : ""} onClick={closeSidebar}>Contact</a>
            </nav>

            <div className="sidebar-footer-centered">
               <a href="tel:+917304398067" className="sidebar-call-btn">
                 <FaPhoneAlt /> Call Now
               </a>
            </div>
          </div>
        </aside>
      </header>
    </>
  );
};

export default Header;